// @flow

import React from "react";
import { Form, FormGroup, Label, Input, FormText, Col, Row, Icons } from "@components";

export type FieldType = $Exact<{
  name: string,
  label: string,
  type?: string,
}>;

export type ValidationType = $Exact<{
  valid: boolean,
  validationMessage: string,
  regex?: RegExp,
}>;

type Props = $Exact<{
  color?: string,
  fields?: FieldType[],
  validations: ValidationType[],
  onChange?: (event: SyntheticEvent<HTMLElement>) => void,
}>;

export const FormValidator = (props: Props) => (
  <Form onChange={props.onChange}>
    <Row>
      {props.fields && (
        <Col>
          {props.fields.map(field => (
            <FormGroup key={field.label}>
              <Label for={field.name}>{field.label}</Label>
              <Input id={field.name} type={field.type} />
            </FormGroup>
          ))}
        </Col>
      )}
      <Col className="pt-3">
        {props.validations.map(validation => (
          <FormText
            key={validation.validationMessage}
            color={validation.valid ? props.color || "positive" : "greyish-brown"}
          >
            <span className="mr-2">
              <Icons.CheckboxIcon
                className="svg-checkbox"
                color={validation.valid ? props.color || "positive" : "greyish-brown"}
              />
            </span>
            {validation.validationMessage}
          </FormText>
        ))}
      </Col>
    </Row>
  </Form>
);

export default FormValidator;
